<template>
    <v-container class="px-6 pt-0 pb-3" style="max-width: 100%;">
    <v-row class="ort-overview-toolbar ma-0 pa-0" style="width: 100%; height: 100%;">
        <v-dialog v-model="abreviations_popup" width="900px" persistent>
            <v-card width="900px">
                <v-row class="ma-0 pa-0">
                    <v-col class="px-6" cols="auto">
                        <v-card-title class="headline ma-0 pa-0">Abbreviations</v-card-title>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn class="ma-0 pa-0" icon @click="abreviations_popup = false" :disabled="abv_change_made">
                            <v-icon color="black">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="ma-0 pa-0">
                    <v-col cols="12" class="ma-0 px-6 pt-0 pb-3">
                        <v-chip label class="data_breakdown_chip" :outlined="abreviations_cat != 'audience'" @click="abreviations_cat = 'audience'" color="black" :disabled="abvs_loading">Audience</v-chip>
                        <v-chip label class="data_breakdown_chip" :outlined="abreviations_cat != 'campaign_name'" @click="abreviations_cat = 'campaign_name'" color="black" :disabled="abvs_loading">Campaign</v-chip>
                        <v-chip label class="data_breakdown_chip" :outlined="abreviations_cat != 'channel'" @click="abreviations_cat = 'channel'" color="black" :disabled="abvs_loading">Channel</v-chip>
                        <v-chip label class="data_breakdown_chip" :outlined="abreviations_cat != 'partner'" @click="abreviations_cat = 'partner'" color="black" :disabled="abvs_loading">Partner</v-chip>
                        <v-chip label class="data_breakdown_chip" :outlined="abreviations_cat != 'format'" @click="abreviations_cat = 'format'" color="black" :disabled="abvs_loading">Format</v-chip>
                    </v-col>
                </v-row>
                <v-card-text>
                    <v-row class="ma-0 pa-0" style="height: 350px;" v-if="abvs_loading" justify="center" align="center">
                        <v-col cols="auto">
                            <v-progress-circular indeterminate size="100" color="black"> </v-progress-circular>
                        </v-col>
                    </v-row>
                    <!-- <v-progress-circular indeterminate v-if="abvs_loading"> </v-progress-circular> -->
                    <v-simple-table :items-per-page="-1" fixed-header height="350px" v-if="!abvs_loading">
                        <thead>
                            <tr>
                                <th class="text-left">Abbreviation</th>
                                <th class="text-left">Meaning</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in localAbbreviations[abreviations_cat]" :key="index">
                                <td width="25%">
                                    <v-text-field v-model="item.abbr" dense outlined hide-details @change="add_new_abbr(item, abreviations_cat)"/>
                                </td>
                                <td>
                                    <span>{{item.full}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                <v-spacer />
                    <v-btn color="primary" @click="save_report_abv" :disabled="!abv_change_made">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-col cols="auto">
            <v-chip label class="data_breakdown_chip" :outlined="selected_page != 'portfolio'" @click="selected_page = 'portfolio'" color="black">Portfolio</v-chip>
            <v-chip label class="data_breakdown_chip" :outlined="selected_page != 'performance'" @click="selected_page = 'performance'" color="black">R/F Review</v-chip>
            <v-chip label class="data_breakdown_chip" :outlined="selected_page != 'overlap'" @click="selected_page = 'overlap'" color="black">Overlap Review</v-chip>
            <v-chip label class="data_breakdown_chip" :outlined="selected_page != 'geographic_review'" @click="selected_page = 'geographic_review'" color="black">Geo Review</v-chip>
            <v-chip label class="data_breakdown_chip" :outlined="selected_page != 'optimizer'" @click="selected_page = 'optimizer'" color="black">Optimization</v-chip>
            <v-chip label class="data_breakdown_chip" :outlined="selected_page != 'blocking'" @click="selected_page = 'blocking'" color="black">Raw Data Review</v-chip>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" v-if="selected_page === 'blocking' || selected_page === 'performance'" class="ma-0 pr-4">
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-chip class="data_breakdown_sub_chip" :outlined="raw_data_type != 'pacing'" @click="raw_data_type = 'pacing'" color="black" v-on="on">
                        <v-icon :color="raw_data_type == 'pacing' ? 'white' : 'black'">mdi-chart-bar</v-icon>
                    </v-chip>
                </template>
                <TooltipDescription title="Pacing"></TooltipDescription>
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-chip class="data_breakdown_sub_chip" :outlined="raw_data_type != 'cumulative'" @click="raw_data_type = 'cumulative'" color="black" v-on="on">
                        <v-icon :color="raw_data_type == 'cumulative' ? 'white' : 'black'">mdi-chart-bell-curve-cumulative</v-icon>
                    </v-chip>
                </template>
                <TooltipDescription title="Cumulative"></TooltipDescription>
            </v-tooltip>
        </v-col>
        <v-col
            cols="auto"
            v-if="selected_page === 'blocking' || selected_page === 'performance' || selected_page === 'geographic_review'"
            class="ort-stat-controls ma-0 px-0"
        >
            <v-tooltip v-for="stat in raw_data_stat_options" :key="stat.value" top>
                <template v-slot:activator="{ on }">
                    <v-chip class="data_breakdown_sub_chip" :outlined="raw_data_stat != stat.value" @click="raw_data_stat = stat.value" color="black" v-on="on">
                        <v-icon :color="raw_data_stat == stat.value ? 'white' : 'black'">{{ stat.icon }}</v-icon>
                    </v-chip>
                </template>
                <TooltipDescription :title="stat.text"></TooltipDescription>
            </v-tooltip>

        </v-col>
        <v-col cols="auto" class="ma-0 pr-0 pl-6" v-if="selected_page === 'performance' || selected_page === 'portfolio' || selected_page === 'overlap'">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="mx-1"
                  icon
                  elevation="0"
                  v-on="on"
                  @click="open_report_abv();"
                  height="32px"
                >
                    <v-icon color="black">mdi-table-of-contents</v-icon>
                </v-btn>
              </template>
              <TooltipDescription title="Report Abv."></TooltipDescription>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="mx-1"
                  icon
                  elevation="0"
                  v-on="on"
                  @click="build_export_pages();"
                  height="32px"
                  disabled
                >
                    <!-- <span class="pr-3">Export</span> -->
                    <v-icon color="black" >mdi-download</v-icon>
                </v-btn>
              </template>
              <TooltipDescription title="Export"></TooltipDescription>
            </v-tooltip>
        </v-col>
        <v-col cols="12" v-if="page_loading || saved_report_loading">
            <v-row class="ma-0 pa-0" style="width: 100%; height: 100%;" align="center" justify="center">
                <v-col cols="auto">
                    <v-progress-circular color="black" size="100" indeterminate></v-progress-circular>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" class="ma-0 pa-0" v-else-if="selected_page == 'portfolio'">
            <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-0 pa-0">
                    <DataLevelTable
                        :tableHeader="headers"
                        :tableData="report_data['portfolio_data']"
                        :selectedLevels="report_data['lvls']"
                        :numericColumns="['frequency','impressions', 'tgt_reach_pop', 'tgt_population', 'mkt_population']"
                        :currencyColumns="[]"
                        :percentageColumns="['reach','tgt_reach']"
                        :decimalColumns="['grp', 'trp']"
                        :filterable="false"
                        :data_filters="{}"
                        :filter_all_vals="{}"
                    />
                </v-col>
            </v-row>
        </v-col>

        <v-col cols="12" class="ma-0 pa-0" v-else-if="selected_page == 'performance'" style="max-height: calc(100vh - 350px); overflow-y: scroll;">
            <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-0 pa-0">
                    <ReachChartV2
                        chart_title = 'Cumulative Reach and Frequency Analysis'
                        :chart_data="report_data['reach_data']"
                        :chart_id="chart_mapping['ort_reach_chart']['chart_id']"
                        :chart_ref="chart_mapping['ort_reach_chart']['chart_ref']"
                        :raw_data_type="raw_data_type"
                        :raw_data_stat="raw_data_stat"
                        :audience_options="report_audiences"
                        :format_options="report_formats"
                    >
                    </ReachChartV2>
                </v-col>
                <v-col cols="6">
                    <ReachComp
                        chart_title = 'Reach Comparison'
                        :chart_data="report_data['reach_comp_data']"
                        :chart_id="chart_mapping['reach_comp_chart']['chart_id']"
                        :chart_ref="chart_mapping['reach_comp_chart']['chart_ref']"
                    >
                    </ReachComp>
                </v-col>
                <v-col cols="6">
                    <LineChart
                        chart_title = 'Frequency Distribution'
                        :chart_data="report_data['frequency_dist_data']"
                        :chart_id="chart_mapping['ort_frequency_dist_chart']['chart_id']"
                        :chart_ref="chart_mapping['ort_frequency_dist_chart']['chart_ref']"
                    >
                    </LineChart>
                </v-col>
                <v-col cols="12" class="ma-0 pa-0">
                    <ReachChartV3
                        chart_title = 'Cumulative Reach and Frequency Analysis'
                        :chart_data="report_data['reach_frequency_data']"
                        :chart_id="chart_mapping['ort_reach_chart']['chart_id']"
                        :chart_ref="chart_mapping['ort_reach_chart']['chart_ref']"
                    >
                    </ReachChartV3>
                </v-col>
                <!-- <v-col cols="12">
                    <HeatMap
                        chart_title = 'Overlap Analysis'
                        :chart_data="report_data['overlap_data']"
                        :chart_id="chart_mapping['ort_overlap_chart']['chart_id']"
                        :chart_ref="chart_mapping['ort_overlap_chart']['chart_ref']"
                    >
                    </HeatMap>
                </v-col> -->
            </v-row>
        </v-col>
        <v-col cols="12" class="ma-0 pa-0" v-else-if="selected_page == 'geographic_review'">
            <v-row class="ma-0 pa-0">
                <v-col cols="12">
                    <GeoMapV2
                        chart_title = 'Map Analysis'
                        :chart_data="report_data['fsa_data']"
                        :raw_data_stat="raw_data_stat"
                        :chart_id="chart_mapping['ort_fsa_chart']['chart_id']"
                        :chart_ref="chart_mapping['ort_fsa_chart']['chart_ref']"
                        ref="ort_fsa_chart"
                    >
                    </GeoMapV2>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" class="ma-0 pa-0" v-else-if="selected_page == 'overlap'" style="max-height: calc(100vh - 350px); overflow-y: scroll;">
            <v-row class="ma-0 pa-0">
                <v-col cols="12">
                    <UpsetPlot
                        chart_title = 'Overlap Groupings'
                        :chart_data="report_data['upset_plot_data']"
                        :chart_id="chart_mapping['ort_upset_plot']['chart_id']"
                        :chart_ref="chart_mapping['ort_upset_plot']['chart_ref']"
                    >
                    </UpsetPlot>
                </v-col>
                <v-col cols="12">
                    <HeatMap
                        chart_title = 'Overlap Analysis'
                        :chart_data="report_data['overlap_data']"
                        :chart_id="chart_mapping['ort_overlap_chart']['chart_id']"
                        :chart_ref="chart_mapping['ort_overlap_chart']['chart_ref']"
                    >
                    </HeatMap>
                </v-col>
                <!-- <v-col cols="12">
                    <GeoMap
                        chart_title = 'Map Analysis'
                        :chart_data="report_data['fsa_data']"
                        :chart_id="chart_mapping['ort_fsa_chart']['chart_id']"
                        :chart_ref="chart_mapping['ort_fsa_chart']['chart_ref']"
                        ref="ort_fsa_chart"
                    >
                    </GeoMap>
                </v-col> -->
            </v-row>
        </v-col>
        <v-col cols="12" class="ma-0 pa-0" v-else-if="selected_page == 'optimizer'" style="max-height: calc(100vh - 350px); overflow-y: auto;">
            <ORTImpressionOptimizer
                :portfolioData="report_data['portfolio_data']"
                :levels="report_data['lvls']"
                :projectId="$project.get_val()"
                :reportId="report_id"
                @triggerAlert="$emit('triggerAlert', ...arguments)"
            />
        </v-col>
        <v-col cols="12" class="ma-0 pa-0" v-else-if="selected_page == 'blocking'">
            <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-0 pa-0">
                    <DataLevelTable
                        :tableHeader="blocking_chart_headers"
                        :tableData="blocking_chart_table_data"
                        :selectedLevels="report_data['lvls']"
                        :numericColumns="blocking_chart_table_numeric_cols"
                        :currencyColumns="[]"
                        :percentageColumns="blocking_chart_table_pct_cols"
                        :decimalColumns="blocking_chart_table_decimal_cols"
                        :filterable="false"
                        :data_filters="{}"
                        :filter_all_vals="{}"
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
    </v-container>
</template>
  
<script>
  import ort_reporting_api_caller from "@/javascript/ort_reporting.js";
  import { ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE } from "@/constants/constants";
  import HeatMap from "@/components/ORT/Charts/HeatMap.vue";
  import UpsetPlot from "@/components/ORT/Charts/UpsetPlot.vue";
  import GeoMapV2 from "@/components/ORT/Charts/GeoMapV2.vue";
  import LineChart from "@/components/ORT/Charts/LineChart.vue";
  import ReachChartV2 from "@/components/ORT/Charts/ReachChartV2.vue";
  import ReachChartV3 from "@/components/ORT/Charts/ReachChartV3.vue";
  import ReachComp from "@/components/ORT/Charts/ReachComp.vue";
  import DataLevelTable from "@/components/Utility/DataLevelTable.vue";
  import ORTImpressionOptimizer from "@/components/ORT/ORTPages/ORTComponents/ORTImpressionOptimizer.vue";
  import { DELAY, EXPORT_DELAY_IN_MS } from "@/constants/constants.js";
  import * as echarts from 'echarts';
  import PPTXBuilderOrtReport from "@/javascript/export_builders/pptxBuilder_ort_report.js";
  import TooltipDescription from "@/components/Utility/TooltipDescription.vue";

  const CHART_MAPPING = {
  ort_reach_chart: {
    chart_ref: "ort_reach_chart",
    chart_id: "ort_reach_chart",
    chart_name: "Reach Analysis Chart",
  },
  ort_frequency_dist_chart: {
    chart_ref: "ort_frequency_dist_chart",
    chart_id: "ort_frequency_dist_chart",
    chart_name: "Frequency Distribution Chart",
  },
  ort_overlap_chart: {
    chart_ref: "ort_overlap_chart",
    chart_id: "ort_overlap_chart",
    chart_name: "Overlap Analysis Chart",
  },
  ort_upset_plot: {
    chart_ref: "ort_upset_plot",
    chart_id: "ort_upset_plot",
    chart_name: "Overlap Groupings Chart",
  },
  ort_fsa_chart: {
    chart_ref: "ort_fsa_chart",
    chart_id: "ort_fsa_chart",
    chart_name: "Map Analysis Chart",
  },
  reach_comp_chart: {
    chart_ref: "reach_comp_chart",
    chart_id: "reach_comp_chart",
    chart_name: "Reach Comp Chart",
  }
};

  export default {
    name: "ORTOverview",
    props: ["report_id"],
    components: {
        HeatMap,
        UpsetPlot,
        GeoMapV2,
        LineChart,
        ReachChartV2,
        ReachChartV3,
        ReachComp,
        DataLevelTable,
        ORTImpressionOptimizer,
        TooltipDescription
    },
    data: () => ({
        client_id: '0000',
        // report_id: 4,
        selected_page: 'portfolio',
        page_loading: true,
        saved_report_loading: false,
        new_plan_loading: false,
        dialogEdit: false,
        editReportPayload: {},
        new_report_name: "",
        ort_reports: [],
        message_queue_payload: "rabbitmq publish test",
        data_filters: {},
        report_data: {
            portfolio_data: [],
            reach_data: [],
            fsa_data: [],
            frequency_dist_data: [],
            overlap_data: {},
            upset_plot_data: [],
            reach_comp_data: {}
        },
        report_start_date: new Date().toISOString().slice(0, 10),
        report_end_date: new Date().toISOString().slice(0, 10),

        report_min_start_date: new Date(new Date().getFullYear(), 0, 1).toISOString().slice(0, 10),
        report_max_end_date: new Date(new Date().getFullYear(), 0, 365).toISOString().slice(0, 10),

        report_name_rules: [
            value => !!value || 'Required.',
        ],
        chart_mapping: CHART_MAPPING,

        abreviations_popup: false,
        abreviations_cat: 'audience',
        localAbbreviations: {},
        abvs_loading: false,
        localAbbreviationChanges: {},
        abv_change_made: false,

        raw_data_type: 'cumulative',
        raw_data_stat: 'reach',
        raw_data_stat_options: [
            {
                icon: 'mdi-monitor-eye',
                text: 'Impressions',
                value: 'impressions'
            },
            {
                icon: 'mdi-account-group-outline',
                text: 'Reach',
                value: 'reach'
            },
            {
                icon: 'mdi-repeat-variant',
                text: 'Frequency',
                value: 'frequency'
            }
        ]
    }),


    async mounted(){
        await this.fetch_report_data();
        // this.page_loading = false;
    },
    watch: {
        async report_id(){
            // this.page_loading = true;
            await this.fetch_report_data();
            // this.page_loading = false;
        }
    },
    computed: {
        report_audiences: function () {
            const portfolioData = Array.isArray(this.report_data['portfolio_data'])
                ? this.report_data['portfolio_data']
                : [];
            const portfolioAudiences = portfolioData
                .map((row) => row && row.audience)
                .filter((audience) => audience != null && String(audience).trim() !== '')
                .map((audience) => String(audience).trim());

            if (portfolioAudiences.length) {
                return [...new Set(portfolioAudiences)];
            }

            const reachFrequencyData = Array.isArray(this.report_data['reach_frequency_data'])
                ? this.report_data['reach_frequency_data']
                : [];
            return [...new Set(reachFrequencyData
                .slice(1)
                .map((row) => row && row[0])
                .filter((audience) => audience != null && String(audience).trim() !== '')
                .map((audience) => String(audience).trim()))];
        },
        report_formats: function () {
            const portfolioData = Array.isArray(this.report_data['portfolio_data'])
                ? this.report_data['portfolio_data']
                : [];
            return [...new Set(portfolioData
                .map((row) => row && row.format)
                .filter((format) => format != null && String(format).trim() !== '')
                .map((format) => String(format).trim()))];
        },
        headers: function () {

            let headers = [
                {
                    "desc": "Reach Percentage Against the Audience Target",
                    "fixed": true,
                    "sortable": false,
                    "text": "On Target Reach %",
                    "value": "tgt_reach"
                },
                {
                    "desc": "Reach Percentage Against Age 18+",
                    "fixed": true,
                    "sortable": false,
                    "text": "A18+ Reach %",
                    "value": "reach"
                },
                {
                    "desc": "The Absolute Reach Population",
                    "fixed": true,
                    "sortable": false,
                    "text": "Reach Population",
                    "value": "tgt_reach_pop"
                },
                {
                    "desc": "The channel for the associated statistics",
                    "fixed": true,
                    "sortable": false,
                    "text": "Impressions",
                    "value": "impressions"
                },
                {
                    "desc": "The channel for the associated statistics",
                    "fixed": true,
                    "sortable": false,
                    "text": "Avg. Frequency",
                    "value": "frequency"
                },
                {
                    "desc": "The channel for the associated statistics",
                    "fixed": true,
                    "sortable": false,
                    "text": "GRPs",
                    "value": "grp"
                },
                {
                    "desc": "The channel for the associated statistics",
                    "fixed": true,
                    "sortable": false,
                    "text": "TRPs",
                    "value": "trp"
                },
                {
                    "desc": "The channel for the associated statistics",
                    "fixed": true,
                    "sortable": false,
                    "text": "Target Pop.",
                    "value": "tgt_population"
                },
                {
                    "desc": "The channel for the associated statistics",
                    "fixed": true,
                    "sortable": false,
                    "text": "Market Pop.",
                    "value": "mkt_population"
                },
            ];
            let lvl = ''
            for(let i = this.report_data['lvls'].length - 1; i > -1; i--){
                lvl = this.report_data['lvls'][i]
                if(lvl == 'audience'){
                    headers.unshift(
                        {
                            "desc": "The channel for the associated statistics",
                            "fixed": true,
                            "sortable": false,
                            "text": "Audience",
                            "value": "audience"
                        }
                    )
                } else if(lvl == 'campaign_name'){
                    headers.unshift(
                        {
                            "desc": "The channel for the associated statistics",
                            "fixed": true,
                            "sortable": false,
                            "text": "Campaign",
                            "value": "campaign_name"
                        }
                    )
                } else if(lvl == 'channel'){
                    headers.unshift( 
                        {
                            "desc": "The channel for the associated statistics",
                            "fixed": true,
                            "sortable": false,
                            "text": "Channel",
                            "value": "channel"
                        }
                    )
                } else if(lvl == 'partner'){
                    headers.unshift(
                        {
                            "desc": "The channel for the associated statistics",
                            "fixed": true,
                            "sortable": false,
                            "text": "Partner",
                            "value": "partner"
                        }
                    )
                } else if(lvl == 'format'){
                    headers.unshift(
                        {
                            "desc": "The channel for the associated statistics",
                            "fixed": true,
                            "sortable": false,
                            "text": "Format",
                            "value": "format"
                        }
                    )
                }
            }
            return headers
        },
        blocking_chart_output: function () {
            return this.report_data["reach_pacing_output"] || {};
        },
        blocking_chart_headers: function () {
            let headers = this.blocking_chart_output["table_headers"] || [];
            let lvl = ''
            for(let i = this.report_data['lvls'].length - 1; i > -1; i--){
                lvl = this.report_data['lvls'][i]
                if(lvl == 'audience'){
                    headers.unshift(
                        {
                            "desc": "The channel for the associated statistics",
                            "fixed": true,
                            "sortable": false,
                            "text": "Audience",
                            "value": "audience"
                        }
                    )
                } else if(lvl == 'campaign_name'){
                    headers.unshift(
                        {
                            "desc": "The channel for the associated statistics",
                            "fixed": true,
                            "sortable": false,
                            "text": "Campaign",
                            "value": "campaign_name"
                        }
                    )
                } else if(lvl == 'channel'){
                    headers.unshift( 
                        {
                            "desc": "The channel for the associated statistics",
                            "fixed": true,
                            "sortable": false,
                            "text": "Channel",
                            "value": "channel"
                        }
                    )
                } else if(lvl == 'partner'){
                    headers.unshift(
                        {
                            "desc": "The channel for the associated statistics",
                            "fixed": true,
                            "sortable": false,
                            "text": "Partner",
                            "value": "partner"
                        }
                    )
                } else if(lvl == 'format'){
                    headers.unshift(
                        {
                            "desc": "The channel for the associated statistics",
                            "fixed": true,
                            "sortable": false,
                            "text": "Format",
                            "value": "format"
                        }
                    )
                }
            }
            console.log('H', headers)
            return headers
        },
        blocking_chart_table_data: function () {
            let variable = ''
            if(this.raw_data_stat == 'reach' && this.raw_data_type == 'pacing'){
                variable = 'Reach Pacing'
            }
            else if(this.raw_data_stat == 'reach' && this.raw_data_type == 'cumulative'){
                variable = 'Reach'
            }
            else if(this.raw_data_stat == 'impressions' && this.raw_data_type == 'pacing'){
                variable = 'Impressions Pacing'
            }
            else if(this.raw_data_stat == 'impressions' && this.raw_data_type == 'cumulative'){
                variable = 'Impressions'
            }
            else if(this.raw_data_stat == 'frequency' && this.raw_data_type == 'pacing'){
                variable = 'Frequency Pacing'
            }
            else if(this.raw_data_stat == 'frequency' && this.raw_data_type == 'cumulative'){
                variable = 'Frequency'
            }


            const tableContent = this.blocking_chart_output["table_content"] || [];
            if (!variable) {
                return [];
            }
            let tmp_dict = {}
            let tmp_data_out = [];
            for(let row of tableContent.filter((row) => row && row[this.report_data['lvls'].length] === variable)){
                tmp_dict = {}
                for(let idx = 0; idx < tableContent[0].length; idx ++){
                    if(tableContent[0][idx] !== 'variable'){
                        if(row[idx] !== ''){
                            tmp_dict[tableContent[0][idx]] = row[idx]
                        }
                    }
                }
                tmp_data_out.push(tmp_dict)
            }
            console.log('TCB', tmp_data_out)
            return tmp_data_out

        },
        blocking_chart_table_pct_cols: function () {
            let headers = [];
            if(this.raw_data_stat == 'reach' && this.raw_data_type == 'pacing'){
                headers = this.blocking_chart_output["table_headers"] || [];
            }
            else if(this.raw_data_stat == 'reach' && this.raw_data_type == 'cumulative'){
                headers = this.blocking_chart_output["table_headers"] || [];
            }
            let cols = []
            for(let h of headers){
                if(!this.report_data['lvls'].includes(h['value'])){
                    cols.push(h['value'])
                }
            }
            return cols
        },
        blocking_chart_table_numeric_cols: function () {
            let headers = [];
            if(this.raw_data_stat == 'impressions'){
                headers = this.blocking_chart_output["table_headers"] || [];
            }
            // else if(this.raw_data_stat == 'impressions' && this.raw_data_type == 'cumulative'){
            //     headers = this.blocking_chart_output["table_headers"] || [];
            // }
            let cols = []
            for(let h of headers){
                if(!this.report_data['lvls'].includes(h['value'])){
                    cols.push(h['value'])
                }
            }
            return cols
        },
        blocking_chart_table_decimal_cols: function () {
            let headers = [];
            if(this.raw_data_stat == 'frequency'){
                headers = this.blocking_chart_output["table_headers"] || [];
            }
            // else if(this.raw_data_stat == 'impressions' && this.raw_data_type == 'cumulative'){
            //     headers = this.blocking_chart_output["table_headers"] || [];
            // }
            let cols = []
            for(let h of headers){
                if(!this.report_data['lvls'].includes(h['value'])){
                    cols.push(h['value'])
                }
            }
            return cols
        },

        create_enabled: function() {
            return this.new_report_name && this.report_start_date && this.report_end_date;
        },
    },
    methods: {
        fetch_report_data: async function() {
            this.page_loading = true;
            let payload = {
                project_id: this.$project.get_val(),
                report_id: this.report_id,
            };

            let token = await this.$auth.getTokenSilently();
            let result = await ort_reporting_api_caller
                .fetch_report_data(token, payload)
                .then((resp) => {
                    if (resp["success"]) {
                        return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log("error", e);
                    return false;
                });
            console.log(result)
            if (result) {
                this.report_data = result;
                this.$emit('reportHighlights', result['highlights']);
                this.page_loading = false;
            } else {
                console.log('NO Output from API')
                this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
            }
        },
        open_report_abv: async function(){
            this.abreviations_popup = true;
            this.abvs_loading = true;
            let payload = {
                project_id: this.$project.get_val(),
            };

            let token = await this.$auth.getTokenSilently();
            let result = await ort_reporting_api_caller
                .fetch_report_abv(token, payload)
                .then((resp) => {
                    if (resp["success"]) {
                    return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log("error", e);
                    return false;
                });

            if (result) {
                this.localAbbreviations = result;
                this.abvs_loading = false;
            } else {
                this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
            }
        },
        add_new_abbr: function(item, abreviations_cat){
            if (!Object.keys(this.localAbbreviationChanges).includes(abreviations_cat)) {
                this.localAbbreviationChanges[abreviations_cat] = {};
            }

            this.localAbbreviationChanges[abreviations_cat][item.full] = item.abbr;
            this.abv_change_made = true;
        },
        save_report_abv: async function(){
            this.abvs_loading = true;

            let payload = {
                project_id: this.$project.get_val(),
                abv_map: this.localAbbreviationChanges
            };

            let token = await this.$auth.getTokenSilently();
            let result = await ort_reporting_api_caller
                .update_report_abv(token, payload)
                .then((resp) => {
                    if (resp["success"]) {
                    return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log("error", e);
                    return false;
                });

            if (result) {
                this.localAbbreviations = result;
                this.abvs_loading = false;
                this.fetch_report_data();
            } else {
                this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
            }
            this.abv_change_made = false;
            this.abreviations_popup = false;
        },
        add_chart_export_element: function(chart_data, chart_name, pptxBuilder) {
            if(chart_data) {
                let chart_image = chart_data.getDataURL({
                    type: 'svg', // You can change the image type here
                    pixelRatio: 5, // Adjust the pixel ratio for higher resolution
                });

                let element = {
                    chart_name: chart_name,
                    chart_image: chart_image
                };

                pptxBuilder.add_element(element, chart_name, 'chart');
            }
        },
        build_export_pages: async function () {

            this.$emit("toggleExportOverlay", true);

            const pptxBuilder = new PPTXBuilderOrtReport('ORT Report Test');
            let element

            this.selected_page = 'portfolio';
            await DELAY(EXPORT_DELAY_IN_MS);
            
            // add overview table element
            element = {
                table_headers: this.headers,
                table_data: this.report_data['portfolio_data'],
            }
            pptxBuilder.add_element(element, 'Overview', 'table')

            this.selected_page = 'performance';
            await DELAY(5000);
            
            for (let chart_key in this.chart_mapping) {

                if(chart_key !== 'ort_fsa_chart'){
                    let chart_id = this.chart_mapping[chart_key]['chart_id'];
                    let chart_name = this.chart_mapping[chart_key]['chart_name'];
                    let chart_data = echarts.getInstanceByDom(document.getElementById(chart_id));

                    this.add_chart_export_element(chart_data, chart_name, pptxBuilder);
                }
            }

            let map_chart_comp = this.$refs['ort_fsa_chart'];
            if(map_chart_comp && map_chart_comp.province_data.length > 0){
                await map_chart_comp.set_up_graph_options();
                await DELAY(3000);

                let chart_id = this.chart_mapping['ort_fsa_chart']['chart_id'];
                let chart_name = this.chart_mapping['ort_fsa_chart']['chart_name'];
                let chart_data = echarts.getInstanceByDom(document.getElementById(chart_id));

                this.add_chart_export_element(chart_data, chart_name, pptxBuilder);
            }

            pptxBuilder.build();
            pptxBuilder.save();

            this.$emit("toggleExportOverlay", false);
        }
    }
  };
  </script>
  
  <style scoped>
    .ort-overview-toolbar {
        position: relative;
        z-index: 2;
    }

    .ort-stat-controls {
        align-items: center;
        display: flex;
        flex: 0 0 auto;
        white-space: nowrap;
    }

    .data_breakdown_sub_chip {
    }

  </style>
  
